var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderNav'),_c('router-view'),_c('FooterNav'),_vm._v(" "),_c('Consultation')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }